import { useEffect, useState } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
// Components
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import Container from '../../Components/Container';
import CarouselNews from '../../Components/CarouselNews';
import LoginModal from '../../Components/LoginModal';
// Redux
import { useDispatch, useSelector } from 'react-redux';
// Slice
import {
	setUserEmail as setUserEmailAction,
	setUserName as setUserNameAction,
	setUserLastname as setUserLastnameAction,
	setUserCode as setUserCodeAction,
	setIpLogin as setIpLoginAction,
	setActiveChat,
	setLms,
} from '../../app/features/userSlice';
// Services
import { getIpUser } from '../../services/getIpUser';
import { getInfoUserMoodle } from '../../services/getInfoUserMoodle';
import { getInfoUserCanvas } from '../../services/getInfoUserCanvas';
import { getInfoUserDigitalOcean } from '../../services/getInfoUserDigitalOcean';
// Images
// IntroJs
import introJs from 'intro.js';
// Styles
import 'intro.js/introjs.css';
import './HomePage.css';
import './NewHomePage.css';
import { getInfoUserBlackboard } from '../../services/getInfoUserBlackboard';
import { handleGetFavorites } from '../../Components/FavoriteButton/utils';
import { useAuth } from '../../hooks/useAuth';
import { isCosmetology } from '../../utils/isCosmetology';
import Loading from '../../Components/Loading';
import { autenticationURL } from '../../services/Login/getInstitutionData';
import { useCookie } from '../../hooks/useCookie';

// Sources IMAGE
import GaleSourceImg from '../../Images/Sources/gale.png';
import PlosSourceImg from '../../Images/Sources/plos.png';
import EuropeSourceImg from '../../Images/Sources/europe-pubmed.png';
import DoajSourceImg from '../../Images/Sources/doaj.png';
import AccessSourceImg from '../../Images/Sources/accessScience.png';
import MobileCarousel from '../../Components/MobileCarousel';
import HomeAquinasSupport from '../../Images/home-support.png';
import HomeAquinasIAHome from '../../Images/ia-section.jpg';
import SparksHome from '../../Images/sparks.png';
import YelloArrow2 from '../../Images/yellow-arrow.png';
import DoYouHaveQuestion3 from '../../Images/do-you-have-3.png';
import GreenBgMobile from '../../Images/HomePage/Sections/green-bg-mobile.png';
import AquinoBottom from '../../Images/aquino-bottom2.png';
import PDFIcon from '../../Images/pdf-icon.png';

import SectionCard from '../../Components/V2/SectionCard';
import { useRedirect } from '../../hooks/useRedirect';
import AquinoReading from '../../Images/aquino-reading.png';
import TopicCard from '../../Components/V2/TopicCards';
import HelpTooltipImgEs from '../../Images/HomePage/Sections/tooltip-help-es.png';
import { getNews } from '../../services/news';
import { Link } from 'react-router-dom';
// Translate
import { useTranslation } from 'react-i18next';
import { NewsCarouselV2 } from '../../Components/V2/NewsCarouselV2';
import { RevealEffect } from '../../Components/RevealEffect';

const HomePage = () => {
	const { t } = useTranslation();
	// const [searchParamsTest, setSearchParam] = useSearchParams()

	// Verify Identity
	const { getCookie, removeCookie } = useCookie('is_validating_identity');
	const [searchParams] = useSearchParams();
	const isHomeWithVerifyIdentityParam = searchParams.get('verify_identity');
	const isVerifyIdentity = isHomeWithVerifyIdentityParam === 'true';
	const [news, setNews] = useState([]);

	// Hooks
	const { redirect } = useRedirect();
	const dispatch = useDispatch();
	const location = useLocation();
	const navigate = useNavigate();
	const {
		isUserLoggedInAndHasLoggingSettingsActive,
		hasHasLoggingSettingsActive,
	} = useAuth();
	const canExecuteLogger = isUserLoggedInAndHasLoggingSettingsActive();
	const hasLoginSettingsActive = hasHasLoggingSettingsActive();
	// Slices
	const { activeLoginModal, ip_login, lms } = useSelector(
		(state) => state.user,
	);
	const { base_news } = useSelector((state) => state.news);
	const { languageInstitution } = useSelector((state) => state.institution);
	const { topics, institutionCode, institutionLogo, assignedLogin } =
		useSelector((state) => state.institution);
	const isCosmetologyInstitution = isCosmetology(institutionCode);
	useEffect(() => {
		getIpUserInit();
		getUserInfo();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.search]);
	const getIpUserInit = () => {
		if (ip_login === '') {
			getIpUser()
				.then((data) => {
					dispatch(setIpLoginAction(data));
				})
				.catch((error) => {
					console.error('Request error:', error);
				});
		}
	};

	const handleGetNews = async (institutionCode) => {
		try {
			const news = await getNews(institutionCode);
			setNews(news);
		} catch (error) {
			console.error('Error fetching news:', error);
		}
	};
	const getUserInfo = () => {
		const currentUrl = new URL(window.location.href);

		const codeParam = searchParams.get('code');
		const userParam = searchParams.get('user');

		if (codeParam) {
			searchParams.delete('code');
			currentUrl.search = searchParams.toString();
			window.history.replaceState({}, '', currentUrl.href);
			dispatch(setUserCodeAction(codeParam));

			if (lms === 'moodle') {
				getInfoUserMoodle(codeParam, institutionCode)
					.then((data) => {
						if (data !== null) {
							data.data.email && dispatch(setUserEmailAction(data.data.email));
							if (data?.data?.email) {
								handleGetFavorites(data?.data?.email, dispatch);
							}
							data.data.firstname &&
								dispatch(setUserNameAction(data.data.firstname));
							data.data.lastname &&
								dispatch(setUserLastnameAction(data.data.lastname));
						}
						navigate('/articles');
					})
					.catch((error) => {
						console.error('Request error:', error);
					});
			}

			if (lms === 'moodle 2.9') {
				getInfoUserMoodle(codeParam, `${institutionCode}_2`)
					.then((data) => {
						if (data !== null) {
							data.data.email && dispatch(setUserEmailAction(data.data.email));
							if (data?.data?.email) {
								handleGetFavorites(data?.data?.email, dispatch);
							}
							data.data.firstname &&
								dispatch(setUserNameAction(data.data.firstname));
							data.data.lastname &&
								dispatch(setUserLastnameAction(data.data.lastname));
						}
						navigate('/articles');
					})
					.catch((error) => {
						console.error('Request error:', error);
					});
			}

			if (lms === 'canvas') {
				getInfoUserCanvas(codeParam, institutionCode)
					.then((data) => {
						const isValidatingIdentityCookie = getCookie();

						if (data !== null) {
							data.data.email && dispatch(setUserEmailAction(data.data.email));
							if (data?.data?.email) {
								handleGetFavorites(data?.data?.email, dispatch);
							}

							data.data.name && dispatch(setUserNameAction(data.data.name));
							data.data.lastname &&
								dispatch(setUserLastnameAction(data.data.lastname));
						}

						// Si existe la cookie y ya el home no tiene parametro verify_identity
						if (isValidatingIdentityCookie && !isVerifyIdentity) {
							removeCookie();
							navigate('/tutorials?download_certificate=true');
							return;
						}

						navigate('/articles');
					})
					.catch((error) => {
						console.error('Request error:', error);
					});
			}

			if (lms === 'digitalocean') {
				getInfoUserDigitalOcean(codeParam, institutionCode)
					.then((data) => {
						if (data !== null) {
							data.data.email && dispatch(setUserEmailAction(data.data.email));
							if (data?.data?.email) {
								handleGetFavorites(data?.data?.email, dispatch);
							}
							const nameParts = data.data.name.split(' ');
							if (data.data.name) {
								dispatch(setUserNameAction(nameParts[0]));
							}
							if (nameParts.length > 1) {
								dispatch(setUserLastnameAction(nameParts.slice(1).join(' ')));
							}
						}
						navigate('/articles');
					})
					.catch((error) => {
						console.error('Request error:', error);
					});
			}
			if (lms === 'blackboard') {
				getInfoUserBlackboard(codeParam, institutionCode)
					.then((data) => {
						const userData = data?.data;

						if (data !== null) {
							userData?.contact.email &&
								dispatch(setUserEmailAction(userData?.contact.email));
							handleGetFavorites(userData?.contact.email, dispatch);
						}

						if (userData?.name.given.length > 0) {
							dispatch(setUserNameAction(userData?.name?.given));
						}

						if (userData?.name.family.length > 0) {
							dispatch(setUserLastnameAction(userData?.name?.family));
						}

						navigate('/articles');
					})
					.catch((error) => {
						console.error('Request error:', error);
					});
			}
		}
		if (userParam) {
			searchParams.delete('user');
			currentUrl.search = searchParams.toString();
			window.history.replaceState({}, '', currentUrl.href);
			dispatch(setUserEmailAction(userParam));
			handleGetFavorites(userParam, dispatch);
			dispatch(setUserNameAction(userParam));
			dispatch(setUserLastnameAction(userParam));
		}
	};

	// const handleGoToSection = (e) => {
	// 	if (!hasLoginSettingsActive) return;
	// 	if (!canExecuteLogger && hasLoginSettingsActive) {
	// 		preventBehavior(e);
	// 		dispatch(setActiveLoginModal(true));
	// 		return;
	// 	}

	// 	return;
	// };

	useEffect(() => {
		if (institutionCode && isCosmetologyInstitution) {
			navigate('/media');
		}

		if (
			institutionCode &&
			!isCosmetologyInstitution &&
			localStorage.introShown === undefined
		) {
			location.pathname === '/' &&
				introJs()
					.setOption('dontShowAgain', true)
					.setOptions({
						showProgress: true,
						showBullets: false,
					})
					.start();
			localStorage.setItem('introShown', 'true');
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [institutionCode, isCosmetologyInstitution, location.search]);

	const getLoginCanvas = () => {
		const hasCanvaLogin = assignedLogin?.includes('canvas');

		if (hasCanvaLogin) {
			dispatch(setLms('canvas'));
			window.location.href = autenticationURL('canvas', institutionCode);
		}
	};

	// Redirecciona al LMS (CANVAS) Para hacer login y obtener la informacion del usuario
	useEffect(() => {
		if (isVerifyIdentity) {
			getLoginCanvas();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isVerifyIdentity]);

	useEffect(() => {
		if (institutionCode) {
			handleGetNews(institutionCode);
		}
	}, [institutionCode]);

	return (
		<>
			{/* Si la institucion es cosmetology y el codigo de la institucion existe, se muestra un loading, esto es para evitar que el usuario vea la pagina de inicio de sesion de cosmetology, ya que no es necesario */}
			{isCosmetologyInstitution && institutionCode && (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '100vh',
					}}
				>
					<Loading height={100} width={100} />
				</div>
			)}

			{/* Si la institucion no es cosmetology y el codigo de la institucion existe, se muestra la pagina de inicio */}
			{!isCosmetologyInstitution && institutionCode && (
				<>
					<Header
						institutionCode={institutionCode}
						institutionLogo={institutionLogo}
					/>
					{activeLoginModal && <LoginModal />}
					<main>
						<section className='metasearchHome'>
							<div
								className='home_header'
								data-title='Welcome to our Website! 👋'
								data-intro="We're excited to have you here. Let's get started with a quick tour of our site's key features."
								data-step='1'
							>
								<Container>
									<div className='header_content'>
										<div
											className='header_title'
											data-title='Congratulations!'
											data-intro="You've completed the onboarding process. Enjoy your journey with us, and remember, we're always here to assist you!"
											data-step='6'
										>
											{t('The easiest way to Find')}
											<br />
											<span className='header_title__knowledge'>
												{t('knowledge')}
											</span>
										</div>
										<div className='header_description'>
											{t('Search for books, journals, and academic articles')}
										</div>
										<button
											// className='header_explore_btn'
											className='bg-white text-black rounded-full px-4 py-2.5 mt-4 border-none hover:!bg-green-aquinas transition-colors duration-200 text-lg'
											onClick={() => redirect('articles')}
										>
											{t('Explore our Library')}
										</button>

										<div className='header_bottom'>
											<div className='left'>
												<div className='header_sources'>
													{t('More than')} <b>150,874</b> {t('sources in just')}{' '}
													<b>{t('one site')}</b>
												</div>
											</div>

											<div className='right'>
												<div className='header_sources_list'>
													<div className='header_source-item gale-item'>
														<img src={GaleSourceImg} alt='gale img' />
													</div>
													<div className='header_source-item plos-item'>
														<img src={PlosSourceImg} alt='plos img' />
													</div>
													<div className='header_source-item pubmed-item'>
														<img src={EuropeSourceImg} alt='europe img' />
													</div>
													<div className='header_source-item doaj-item'>
														<img src={DoajSourceImg} alt='doaj img' />
													</div>
													<div className='header_source-item access-item'>
														<img src={AccessSourceImg} alt='access img' />
													</div>
												</div>
											</div>
										</div>
									</div>
								</Container>
							</div>
						</section>

						<RevealEffect>
							<section className='sections-home'>
								<Container className='pt-8 md:py-10 xl:py-16'>
									<div className='flex gap-5 justify-between items-start mb-11'>
										<h3 className='text-2xl md:text-4xl font-semibold'>
											{t('Your All-in-One')}
										</h3>
										<Link
											to='/articles'
											className='bg-white text-black rounded-full px-4 py-2.5 text-center border border-black hover:!bg-green-aquinas transition-colors duration-200 text-lg'
										>
											{t('Explore all resources')}
										</Link>
									</div>

									{/* Mobile */}
									<MobileCarousel visibleItems={1} />

									{/* Desktop */}
									<SectionCard />
								</Container>
							</section>
						</RevealEffect>

						<RevealEffect>
							<section className=' flex g-[25px] animate__animated animate__fadeInUp	'>
								<Container className='px-[1rem] relative'>
									<div className='bg-[#f5f5f7] flex flex-col xl:flex-row gap-7 justify-center items-center w-full py-28 px-4 xl:px-20 rounded-3xl'>
										<div className='section-find-hundred-header'>
											<div className='home-title !font-medium px-4 lg:!px-12'>
												<div>
													{t('Find hundreds of sources searching by topics')}
												</div>
												{/* <div className='aquino-img'>
												<img
													loading='lazy'
													src={AquinoReading}
													alt='Aquino Reading'
												/>
											</div> */}
											</div>
											<div className='home-description px-4 lg:!px-12'>
												{t('Access specialized resources organized')}
											</div>
										</div>

										<div className='topic-cards mt-4 lg:mt-0'>
											{topics &&
												topics?.map((topic, i) => (
													<TopicCard
														key={i}
														iconSrc={topic?.path}
														title={topic.name}
														canExecuteLogger={canExecuteLogger}
														hasLoginSettingsActive={hasLoginSettingsActive}
														name={topic?.name}
														isDark={(i + 1) % 2 === 0}
													/>
												))}
										</div>
									</div>
									<img
										loading='lazy'
										src={AquinoReading}
										alt=''
										className='w-[63px] h-[84px] absolute bottom-0 right-4'
									/>
								</Container>
							</section>
						</RevealEffect>

						<RevealEffect>
							<section className='animate__animated animate__fadeInUp	'>
								<Container className='flex flex-col lg:flex-row justify-between items-center mb-4'>
									<div className='w-full pt-20 lg:pt-0 lg:w-1/2 lg:pl-6 xl:w-1/3 xl:pl-12  '>
										<div className='text-xl text-center md:text-xl lg:!text-left lg:text-2xl xl:text-4xl lg:max-w-[500px] font-medium relative'>
											<img
												src={SparksHome}
												alt='sparks'
												className='absolute hidden xl:block h-[20px] w-[20px] top-[-0.5rem] left-[0rem] lg:top-[-2rem] xl:left-[-3rem] xl:w-[40px] xl:h-[40px]'
											/>
											{t('your virtual study partner')}
										</div>
										<p className='text-base text-center lg:!text-left font-normal mt-4 lg:max-w-[660px]'>
											{t('optimize your learning')}
										</p>
									</div>

									<div className='w-full lg:w-1/2 lg:pr-12 xl:w-2/3'>
										<img
											src={HomeAquinasIAHome}
											alt='Help Aquinas '
											className='p-2 lg:p-10 hover:scale-105 transition-all duration-300'
										/>
									</div>
								</Container>
							</section>
						</RevealEffect>

						<RevealEffect>
							<Container className='animate__animated animate__fadeInUp	'>
								<section
									className='px-2 py-4 flex flex-col lg:flex-row lg:justify-between lg:items-center lg:!py-8 lg:!px-0 xl:!py-14 xl:gap-x-10 rounded-2xl'
									style={{
										background: `url(${GreenBgMobile})`,
										backgroundRepeat: 'no-repeat',
										backgroundSize: 'cover',
									}}
								>
									{/* Left */}
									<div className='px-4 lg:w-[60%] lg:!px-0'>
										<img
											loading='lazy'
											src={HomeAquinasSupport}
											alt=''
											className='rounded-2xl lg:rounded-tr-2xl lg:rounded-br-2xl lg:rounded-tl-none lg:rounded-bl-none xl:max-w-[844px] w-full hover:scale-105 transition-all duration-300'
										/>
									</div>

									{/* Right */}
									<div className='mt-4 px-4 lg:w-[40%]'>
										<div className='need-help relative w-fit'>
											<img
												loading='lazy'
												src={
													languageInstitution === 'en'
														? DoYouHaveQuestion3
														: HelpTooltipImgEs
												}
												alt='tooltip'
												className='!w-full !h-full !max-w-[380px] mb-4'
											/>

											<img
												loading='lazy'
												src={YelloArrow2}
												alt=''
												className='absolute bottom-[-1rem] right-[-4rem] hidden xl:block'
											/>
										</div>

										{/* Title */}
										<div className='text-xl lg:text-2xl xl:text-3xl text-white'>
											<b>{t('Need help?')}</b>{' '}
											{t("We're here to help you every step of the way")}
										</div>

										{/* Description */}
										<div className='mt-4 text-white'>
											<p className='text-white'>
												{t('We understand that while browsing')}
											</p>
											<div className='help-arrow-container'>
												<p className='text-white mt-4'>
													{t('In any library view')}{' '}
													<b>
														{t('Do you have any questions or suggestions?')}
													</b>{' '}
													{t('This is your direct access to our support team')}
												</p>
											</div>
											<p className='font-semibold mt-4 text-white'>
												{t('Your question has a place, and so does our answer')}
											</p>
										</div>

										<div className='mt-4'>
											<button
												onClick={() => dispatch(setActiveChat(true))}
												className='border border-white rounded-full bg-black/30 px-4 py-3 text-white hover:bg-green-100/20 hover:text-white'
											>
												{t('Submit a support request')}
											</button>
										</div>
									</div>
								</section>
							</Container>
						</RevealEffect>

						{news && news?.length > 0 && (
							<RevealEffect>
								<section className=' pt-24 animate__animated animate__fadeInUp	'>
									<Container>
										<div className='text-3xl font-medium text-center mb-8'>
											{t('new releases notice board')}
										</div>
										<NewsCarouselV2 items={news} />
									</Container>
								</section>
							</RevealEffect>
						)}

						<RevealEffect>
							<section className='w-full py-10 animate__animated animate__fadeInUp	'>
								<Container className='mx-aut'>
									<div className='relative overflow-hidden rounded-[28px] bg-[#F3F4F6] px-8 py-10 sm sm:px-12 sm:py-14'>
										<div className='flex flex-col justify-between items-center lg:flex-row gap-x-10'>
											{/* Left */}
											<div className='max-w-[420px] xl:pl-12'>
												<h2 className='text-4xl font-medium	 leading-[1.05] tracking-[-0.02em] text-slate-900 sm:text-3xl'>
													{t('Learn about our Collection Development Policy')}
												</h2>

												<p className='mt-6 max-w-xl text-[15px] leading-6 text-slate-700'>
													{t('In our library, every resource counts')}
												</p>
											</div>

											<div className='hidden lg:block w-[50px] '>
												<img
													loading='lazy'
													src={AquinoBottom}
													alt=''
													className='h-[61px] w-[44px]'
												/>
											</div>

											{/* Right */}
											<div className='flex items-center gap-10 justify-self-start lg:justify-self-end max-w-[800px] mt-8 xl:pr-12'>
												<div className='max-w-md'>
													<div className='buttons flex flex-wrap justify-center md:justify-start gap-4 !gap-x-2 '>
														{/* Download button */}
														<button
															type='button'
															className='shadow-[0_22px_70px_rgba(34,197,94,0.35),0_10px_24px_rgba(0,0,0,0.06)] active:scale-[0.99] hover:shadow-[0_26px_85px_rgba(34,197,94,0.45),0_12px_28px_rgba(0,0,0,0.08)] max-w-[210px] w-full inline-flex items-center gap-3 rounded-full bg-white px-4 py-2 text-xs font-semibold text-slate-900  hover:bg-slate-50 hover:scale-105 transition-all duration-300'
															onClick={() =>
																window.open(
																	'https://institutions-assets.s3.us-east-2.amazonaws.com/static/collection_development_policy.pdf',
																	'_blank',
																)
															}
														>
															<img
																src={PDFIcon}
																alt=''
																className='w-full max-w-[33px]'
															/>
															Download English
														</button>

														{/* Download button */}
														<button
															type='button'
															className='shadow-[0_22px_70px_rgba(34,197,94,0.35),0_10px_24px_rgba(0,0,0,0.06)] active:scale-[0.99] hover:shadow-[0_26px_85px_rgba(34,197,94,0.45),0_12px_28px_rgba(0,0,0,0.08)] max-w-[210px] w-full inline-flex items-center gap-3 rounded-full bg-white px-4 py-2 text-[11.5px] font-semibold text-slate-900  hover:bg-slate-50 hover:scale-105 transition-all duration-300'
															onClick={() =>
																window.open(
																	'https://institutions-assets.s3.us-east-2.amazonaws.com/static/Politica_de_Desarrollo_de_Colecciones_Olib.pdf',
																	'_blank',
																)
															}
														>
															<img
																src={PDFIcon}
																alt=''
																className='w-full max-w-[33px]'
															/>
															Descargar Español
														</button>
													</div>

													<p className='mt-4 text-[15px] leading-6 text-slate-700'>
														{t("If you'd like to know how we select content")}
														<span className='font-semibold text-slate-900'>
															{' '}
															{t('Download the full policy')}
														</span>
													</p>
												</div>
											</div>
										</div>
									</div>
								</Container>
							</section>
						</RevealEffect>

						<RevealEffect>
							<section className='newsHome animate__animated animate__fadeInUp	'>
								<Container className='newsHomeContainer'>
									<h2 className='newsHomeContainerTitle'>
										{t('Discover all the')} <b>{t('scientific news')}</b>
									</h2>
									<p className='newsHomeContainerText'>
										{t('Stay up to date with news and updates')}
									</p>
									<div className='carouselNewsInfoPage'>
										<CarouselNews
											news={base_news.slice(0, 4)}
											canExecuteLogger={canExecuteLogger}
											hasLoginSettingsActive={hasLoginSettingsActive}
											language={languageInstitution}
										/>
									</div>
								</Container>
							</section>
						</RevealEffect>
					</main>
					<RevealEffect>
						<Footer />
					</RevealEffect>
				</>
			)}
		</>
	);
};

export default HomePage;
